import React from "react";
import { Controller } from "react-hook-form";
import { formatDate } from "../utilities/formatInput";

export default function DateComponent(props) {
    return (
        <React.Fragment>

            <label htmlFor={props.htmlFor}>{props.label}
                {
                    props.isStrong ?
                        <strong className="text-primary">*</strong>
                        :
                        null
                }
            </label>
            <div className="input-group">
                <Controller
                    name={props.name}
                    control={props.control}
                    rules={{
                        required: props.required,
                        pattern: {
                            value: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                            message: props.invalidMessage
                        }
                    }}
                    render={({ field: { onChange, value, ref, name, onBlur } }) => (
                        <input
                            ref={ref}
                            type="text"
                            name={name}
                            id={props.htmlFor}
                            className="form-control"
                            placeholder={props.placeholder}
                            value={value ?? ''}
                            onBlur={onBlur}
                            onChange={(event) => onChange(formatDate(event.target.value))}
                        />
                    )}
                />
            </div>
            <small className="text-primary" id={props.id}>
                {props?.errMsg}
            </small>
        </React.Fragment>
    );
}
